import type { NavItem } from '@/app/nav/collect'

/**
 * No menu entry: legacy linked the three account lists from nowhere — an operator types the URL (wp/admin §3).
 */
const nav: NavItem[] = []

export default nav
